import { RefObject, useEffect, useRef } from 'react';

export const useRachelAttachmentsAutoScroll = (
  rowRef: RefObject<HTMLDivElement | null>,
  attachmentCount: number,
) => {
  const previousCountRef = useRef(attachmentCount);

  useEffect(() => {
    const hasNewAttachment = attachmentCount > previousCountRef.current;
    previousCountRef.current = attachmentCount;

    if (!hasNewAttachment || !rowRef.current) {
      return;
    }

    rowRef.current.scrollTo({ left: rowRef.current.scrollWidth });
  }, [attachmentCount, rowRef]);
};
